<script lang="ts">
	import cross from '$lib/assets/images/cross.svg';
	import label from '$lib/assets/images/label.png';
	import arrowWhite from '$lib/assets/images/arrow_white.svg';
	import arrowBlack from '$lib/assets/images/arrow_black.svg';

	import {
		formOpen,
		masters,
		questions,
		quizAnswers,
		quizOpen,
		selectedMaster
	} from '$lib/index.svelte';
	import thumbstack from '$lib/assets/images/trombone.png';

	let currentQuestion = $state(0);

	function quizRes() {
		currentQuestion = 0;
		quizOpen.status = false;
		formOpen.status = true;
	}

	function nextQuestion() {
		currentQuestion++;
		if (currentQuestion >= questions.length) {
			const scores = [0, 0, 0];
			for (let i = 0; i < quizAnswers.length; i++) {
				if (quizAnswers[i] === 'a') scores[0]++;
				else if (quizAnswers[i] === 'b') scores[1]++;
				else if (quizAnswers[i] === 'c') scores[2]++;
			}
			const max = Math.max(...scores);
			const winners = scores
				.map((score, idx) => (score === max ? idx : -1))
				.filter((idx) => idx !== -1);
			selectedMaster.idx = winners[Math.floor(Math.random() * winners.length)];
		}
	}
</script>

<div
	class="fixed inset-0 z-5 flex min-h-lvh w-full items-center justify-center bg-black/10 backdrop-blur-2xl md:p-5"
>
	<div
		class="h-screen w-screen overflow-auto bg-white px-8 pt-5 pb-10 text-black md:h-auto md:max-h-[calc(100vh-40px)] md:w-140"
	>
		<div class="flex items-center justify-between">
			<span></span>
			<h2 class="font-semibold uppercase">
				{#if currentQuestion + 1 <= questions.length}
					Quiz
				{:else}
					Quiz results
				{/if}
			</h2>
			<button
				onclick={() => {
					quizOpen.status = false;
				}}
				aria-label="Close the quiz"><img src={cross} alt="" /></button
			>
		</div>
		{#if currentQuestion + 1 <= questions.length}
			<div class="mt-10 md:mx-8 md:mt-0">
				<div class="flex items-center justify-between">
					<p>
						question {currentQuestion + 1} of {questions.length}
					</p>
					<p>
						{Math.round((currentQuestion * 100) / questions.length)}%
					</p>
				</div>
				<div class="relative h-0.75 w-full rounded-full bg-gray-200">
					<div
						class="absolute h-0.75 rounded-full bg-theme-brown"
						style="width:{Math.round((currentQuestion * 100) / questions.length)}%"
					></div>
				</div>
			</div>
		{/if}
		{#if currentQuestion + 1 <= questions.length}
			<div class="mt-10.5 md:mx-8">
				<h3 class="mb-7 text-[24px]">
					{questions[currentQuestion].question}
				</h3>
				<div class="flex flex-col gap-3">
					{#each questions[currentQuestion].answers as answer (answer.value)}
						<label
							class="flex items-center rounded-sm border px-3 py-3.75 leading-[110%] has-checked:bg-black has-checked:text-white"
						>
							<input
								class="accent-black"
								type="radio"
								name="answer"
								bind:group={quizAnswers[currentQuestion]}
								value={answer.value}
							/>
							<span class="ml-2 font-mono">{answer.text}</span>
						</label>
					{/each}
				</div>
				<div class="flex justify-between">
					{#if currentQuestion > 0}
						<button
							class="mt-10.5 flex items-center gap-2 rounded-sm border border-black bg-white p-3 font-semibold text-black uppercase"
							onclick={() => {
								currentQuestion--;
							}}
						>
							<img class="w-4 rotate-180" src={arrowBlack} alt="" />
							back
						</button>
					{:else}
						<div></div>
					{/if}
					<button
						class="mt-10.5 flex items-center gap-2 rounded-sm border border-black bg-black p-3 font-semibold text-white uppercase"
						disabled={quizAnswers[currentQuestion] === undefined &&
							currentQuestion + 1 <= questions.length}
						onclick={nextQuestion}
					>
						next
						<img class="w-4" src={arrowWhite} alt="" />
					</button>
				</div>
			</div>
		{:else}
			{@const selected = masters[selectedMaster.idx ?? 0]}
			<div>
				<div>
					<div class="relative mb-10.5">
						<div class="relative mx-auto h-77.5 w-68.75 rotate-5">
							<img
								class="h-full w-full border-10 border-taupe-200 object-cover"
								src={selected.image}
								alt="{selected.firstName} {selected.lastName}'s portrait"
							/>
							<img
								class="absolute top-0 right-5 h-29 translate-y-[-18%] rotate-7"
								src={thumbstack}
								alt=""
							/>
						</div>

						<img
							class="absolute bottom-0 left-1/2 w-45 translate-x-[-150%] -rotate-26 mix-blend-difference"
							src={label}
							alt=""
						/>
					</div>
				</div>
				<h3
					class="py-10 text-center text-xl font-semibold tracking-[-1px] uppercase md:text-[28px]"
				>
					Your Maître Fromager is {selected.firstName}!
				</h3>
				<p class="mb-10 text-center">
					{selected.text}
				</p>
				<div class="flex justify-between">
					<button
						class="mt-10.5 flex items-center gap-2 rounded-sm border border-black bg-white p-3 font-semibold text-black uppercase"
						onclick={() => {
							currentQuestion--;
						}}
					>
						<img class="w-4 rotate-180" src={arrowBlack} alt="" />
						back</button
					>
					<button
						class="mt-10.5 flex items-center gap-2 rounded-sm border border-black bg-black p-3 font-semibold text-white uppercase"
						onclick={quizRes}>next <img class="w-4" src={arrowWhite} alt="" /></button
					>
				</div>
			</div>
		{/if}
	</div>
</div>
